import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

export class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // get leaf of the future route tree, check if it has reuseComponent data property, if not check the current route tree, if not found default to false
    const leaf = this.#getChildNode(future);
    const currentLeaf = this.#getChildNode(curr);

    if (leaf.component !== currentLeaf.component) {
      return false;
    }

    const reuse = leaf?.data['reuseComponent'] || false;
    return reuse;
  }

  #getChildNode(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if (route.firstChild) {
      return this.#getChildNode(route.firstChild);
    }
    return route;
  }
}
